import { BannerType } from '@/modules/core/ui/constants/BannerType';

export const BannerMixin = {
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    titleTextSize: {
      type: String,
      default: 'is-size-3',
      validator: (prop) =>
        ['is-size-1', 'is-size-2', 'is-size-3', 'is-size-4', 'is-size-5', 'is-size-6'].includes(
          prop
        )
    },
    type: {
      type: String,
      default: BannerType.IS_SUCCESS,
      validator: (prop) => Object.values(BannerType).includes(prop)
    },
    showClose: {
      type: Boolean,
      default: false
    },
    isBorderless: {
      type: Boolean,
      default: false
    },
    hasIcon: {
      type: Boolean,
      default: true
    },
    customIcon: {
      type: String,
      required: false
    }
  }
};
